const getDocumentName = ({ name, url, document } = {}, documents) => {
  if (name) {
    return name;
  }
  if (url) {
    return url;
  }
  if (document?.info) {
    const info = document.info;
    if (info.title) {
      return info.title;
    }
  }
  return "default";
};
export {
  getDocumentName
};
//# sourceMappingURL=get-document-name.js.map
